module.exports = __webpack_public_path__ + "static/google_play@3x-c483fef60248f7ea3f5cc04f510fdc54.png";